var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.Renewal },
                  model: {
                    value: _vm.paramsData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_prod", $$v)
                    },
                    expression: "paramsData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addSpeaking.open({}, 2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchOperation")))]
              ),
              _c("uploadImagetow", {
                ref: "uploadImagetow",
                staticStyle: { "margin-right": "10px" },
                attrs: {
                  Url: "/hjhd-gm/update-ban-user-file",
                  filesname: "ban_user_file",
                  paramsData: _vm.paramsData,
                  title: _vm.$t("batchUpload")
                },
                on: {
                  change: function($event) {
                    return _vm.getList(1)
                  }
                }
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "success", disabled: !_vm.sels.length },
                  on: {
                    click: function($event) {
                      return _vm.unseal(_vm.sels)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchUnban")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function() {
                      _vm.tableData = []
                      _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("refresh")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "accid", type: "selection", width: "50" }
          }),
          _c("el-table-column", {
            attrs: { prop: "accid", label: _vm.$t("roleId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "expire", label: _vm.$t("banTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.expire == 0 ? _vm.$t("permanentBan") : row.expire
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "ban_type", label: _vm.$t("muteType") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.ban_type == "" ? _c("div", [_vm._v("/")]) : _vm._e(),
                    row.ban_type == 0
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("fullMute")))])
                      : _vm._e(),
                    row.ban_type == 1
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("expel")))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("operation"), width: "160", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.unseal([row])
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("unban")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addSpeaking", {
        ref: "addSpeaking",
        attrs: { prod: { is_prod: _vm.paramsData.is_prod } },
        on: { change: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }